import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs';
import { ErrorDialogComponent } from 'src/app/components/utility/error-dialog/error-dialog.component';
import { cacheKeys } from 'src/app/constants/cache-keys';
import { states } from 'src/app/constants/states';
import { searchIconSVG } from 'src/app/constants/svgs/search-icon';
import { iterateAPIConfig } from 'src/app/helpers/api-resp-helper';
import { generateSlug } from 'src/app/helpers/slug-helper';
import { createDeptUrl } from 'src/app/helpers/url-helper';
import { PageAPIResp } from 'src/app/models/api-config.model';
import { APIConfigService } from 'src/app/services/api-config.service';
import { CallAPIService } from 'src/app/services/call-api.service';
import { LanguageHandlerService } from 'src/app/services/language-handler.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { StoreService } from 'src/app/services/store.service';
import { UtilsService } from 'src/app/services/utils.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-global-search',
  templateUrl: './global-search-dialog.component.html',
  styleUrls: ['./global-search-dialog.component.scss'],
})
export class GlobalSearchDialogComponent implements OnInit, OnDestroy {
  states = states;
  activeLink: boolean = false;
  public searchIconSVG = searchIconSVG;
  public search = new FormControl();
  public searchResult: any[] = [];
  public filteredSearchResult: any[] = [];
  public deptList: any = [];
  public serviceList: any = [];
  public keySearchResultRes: any = [];
  public categoryList: any = [];
  public filteredStates: any[] = [];
  public isDeptSrvVisible: any;
  public searchedKeyResult = false;
  public regional: boolean = false;
  public clickedRegion: any = 'A';
  public clickedType: any = 'S';
  public clickedCategory: any;
  public clickedState: any;
  public searchKeyResult: any;
  allAPIsResp: PageAPIResp = {};
  public trendingList: any[] = [];
  public recentSearch: any = [];
  public isDrawerVisible = true;
  public isLoading = true;
  public trendingServiceCacheKey = cacheKeys.trendingSrvs;
  public searchKeyLength: any = 0;
  public resultAvailable: boolean = false;
  public isFocus = false;
  public isDepartment = true;
  trend: any;
  public filterValues: any = {
    region: 'A',
    category: null,
    type: 'S',
    state: null,
  };
  servicesList: any;
  suggestedResult: any;
  private destroy$ = new Subject<void>();
  private keyupSubject = new Subject<KeyboardEvent>();

  constructor(
    private callApiService: CallAPIService,
    private router: Router,
    private matDialog: MatDialog,
    public storeService: StoreService,
    private apiConfigService: APIConfigService,
    private ngZone: NgZone,
    public shareDataService: ShareDataService,
    public langHandlerService: LanguageHandlerService,
    private utilService: UtilsService

  ) {}

  ngOnInit(): void {
    this.recentSearchResult();
    iterateAPIConfig(
      this.apiConfigService.getGlobalSearchConfig(),
      this.allAPIsResp
    );
    this.fetchSearchTrendingList();
    this.searchValChangeSubscription();

    this.keyupSubject
      .pipe(
        debounceTime(300), // Adjust the debounce time as needed
        switchMap((event: KeyboardEvent) => {
          const input = event.target as HTMLInputElement;
          const keyupMessage = `${input.value}`;
          return this.callApiService.callSearchSuggestionAPI('', { query: keyupMessage, language:'en',alias:'all' });
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((res:any) => {
        if (res) {
          const result = res?.data
          if(result && result.length > 0) {
            this.suggestedResult = result;
          }
          else this.suggestedResult = null;
        }
      });
  }

  get displayList() {
    return this.ngZone.run(() => {
      let disList: any[] = [...this.searchResult];
      let collection: any = {
        count: 0,
        list: [],
      };
      Object.keys(this.filterValues).forEach((key) => {
        const filterValue = this.filterValues[key];
        if (filterValue) {
          this.resultAvailable = true;
          if (key == 'region') {
            disList = disList.filter((elm) =>
              filterValue == 'A'
                ? true
                : filterValue == 'C'
                ? elm.state == '99'
                : true
            );
            // && elm.dept_type != 'I'
            collection.count = disList.length;
            collection.list = disList;
          } else if (key == 'state') {
            disList = disList.filter(
              (elm) =>
                elm.state == filterValue ||
                (elm.other_states.split('|').includes(filterValue) &&
                  elm.dept_type != 'I')
            );
            collection.count = disList.length;
            collection.list = disList;
          } else if (key == 'category') {
            disList = disList.filter((elm) => elm.cgid == filterValue);
            collection.count = disList.length;
            collection.list = disList;
          } else if (key == 'type') {
            disList = disList.filter((elm) => elm.catlg_type == filterValue);
            collection.count = disList.length;
            collection.list = disList;
          }
        } else {
          this.resultAvailable = false;
        }
      });
      return collection;
    });
  }

  get isValid(){
    return (this.isDepartment && !this.clickedCategory && this.clickedRegion=='A' && !this.clickedState);
  }

  filterByCategory(category: any) {
    if (this.clickedCategory == category.categoryId) {
      this.clickedCategory = null;
    } else {
      this.clickedCategory = category.categoryId;
    }
    if (this.filterValues.category == category.categoryId) {
      this.filterValues.category = null;
      return;
    }
    this.filterValues.category = category.categoryId;
  }

  filterByState(state: any) {
    if (this.clickedState == state.stateId) {
      this.clickedState = null;
    } else {
      this.clickedState = state.stateId;
    }

    if (this.filterValues.state == state.stateId) {
      this.filterValues.state = null;
      return;
    }
    this.filterValues.state = state.stateId;
    this.isDepartment = false;
  }

  filterByRegion(type: any) {
    this.regional = false;
    this.filterValues.region = type;
    this.clickedRegion = type;
    if (type == 'R') {
      this.regional = true;
      this.isDepartment = false;
    }
    if (type != 'R') {
      this.filterValues.state = null;
      this.clickedState = null;
      this.isDepartment = false;
    }
    if(type=='A') this.isDepartment = true;
  }

  toggleState() {
    this.regional = !this.regional;
    this.clickedRegion = 'R';
    this.filterValues.region = 'R';
    if (!this.regional) {
      this.clickedRegion = 'A';
      this.filterValues.state = null;
      this.isDepartment = true;
      this.clickedState = null;
      this.filterValues.region = 'A';
    }
  }

  filterByType(type: any) {
    this.filterValues.type = type;
    this.clickedType = type;
    // this.isDepartment = !this.isDepartment;
  }

  getFilteredCategory(departmentList: any) {
    const uniqueCategory = Object.values(
      departmentList.reduce((acc: any, item: any) => {
        if (!acc[item.category_name]) {
          acc[item.category_name] = {
            categoryId: item.cgid,
            categoryName: item.category_name,
          };
        }
        return acc;
      }, {} as { categoryId: number; categoryName: string })
    );

    this.categoryList = uniqueCategory;
  }

  getFilteredState(departmentList: any) {
    let uniqueState: any[] = [];
    for (let i = 0; i < departmentList.length; i++) {
      if (uniqueState.indexOf(departmentList[i].state) === -1) {
        uniqueState.push(departmentList[i].state);
      }
    }
    const filterState = uniqueState.map((state) => {
      return this.states.filter((elm) => {
        return elm.stateId == state;
      });
    });
    this.filteredStates = filterState.flat();
  }

  searchValChangeSubscription() {
    this.search.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((key) => {
        if (key.length) {
          this.searchedKeyResult = true;
          this.getKeySearchResult(key);
        } else this.searchedKeyResult = false;
      });
  }

  getKeySearchResult(searchKeywords: any) {
    this.callApiService.appLangSearch(searchKeywords).subscribe((res: any) => {
      this.keySearchResultRes = res.response.docs;
      this.searchResult = [];
    });
  }

  navigateToDeptInfo(item: any, type: string) {
    if (type === 'department') {
      this.router.navigateByUrl(`/department/${generateSlug(item.department_name)}`);
    } else {
      this.redirectToService(item);
    }
  }

  redirectToService(item: any, customMsg?: string) {
    const services:any = this.servicesList.map((item:any) => {
      return {
        name: item.service_name,
        url: item.url,
        deptImageUrl: item.image_url,
        deptName: item.department_name,
        desc: item.description,
        rating: item.score,
        id: item.service_id,
        type: item.service_type,
        platformList: 'all',
        deptId: item.department_id
      }
    })

    const service:any = {
      name: item.service_name,
        url: item.url,
        deptImageUrl: item.image_url,
        deptName: item.department_name,
        desc: item.description,
        rating: item.score,
        deptId: item.department_id,
        type: item.service_type
    }

    if (customMsg) {
      this.matDialog.open(ErrorDialogComponent, { data: customMsg });
    }

    const isLoadService = this.utilService.checkSrvAccess(
      item.service_id,
      service,
      services
    );

    if (!isLoadService) {
      return;
    }

    const webNewUrl = `${environment.deployUrl}/web_new/department`;
    const isUrlV2 = item.url.includes('UmangVersion2');
    const isUrlDeptt = item.url.includes('deptt');

    if (isUrlV2) {
      const urlParams = encodeURIComponent(
        `${createDeptUrl(item.url)}&dept_id=${item.department_id}&dept_name=${
          item.department_name
        }`
      );
      window.open(`${webNewUrl}?url=${urlParams}`, '_self');
      return;
    } else if (isUrlDeptt) {
      const encodedUrlParam = encodeURIComponent(`${createDeptUrl(item.url)}`);
      window.open(
        `${webNewUrl}?url=${encodedUrlParam}&dept_id=${item.department_id}&dept_name=${item.department_name}`,
        '_self'
      );
      return;
    }

    const urlParams =
      encodeURIComponent(`${item.url.split('gov.in/')[1]}`) +
      `&dept_id=${item.department_id}&dept_name=${item.department_name}`;
    window.open(`${webNewUrl}?url=${urlParams}`, '_self');
  }

  onServiceClick(serviceName: string) {
    // this.recentSearchResult(serviceName);
    // this.isDrawerVisible = false;
    // if (!serviceName) {
    //   return;
    // }

    // this.router.navigateByUrl(`/department/${generateSlug(serviceName)}`);
  }

  getSearchResult(enteredKey?: any) {
    let targettedVal = enteredKey.alises;
    this.isDrawerVisible = false;
    this.storeService.filteredResult = true;
    this.isLoading = true;
    this.callApiService
      .appLangSearch(targettedVal, '*', '*', false)
      .pipe(
        tap({
          next: () => {
            this.isLoading = false;
          },
          error: () => {
            this.isLoading = false;
          },
        })
      )
      .subscribe((res: any) => {
        if (res?.response?.docs) {
          this.searchResult = res?.response?.docs;
          this.storeService.filteredResult = true;
          // this.keySearchResult(res?.response?.docs);
          this.recentSearchResult(targettedVal);
          this.getFilteredCategory(this.searchResult);
          this.getFilteredState(this.searchResult);
        }
      });
  }

  keySearchResult(event: any) {
    this.searchKeyResult = event;
    this.storeService.filteredResult = false;
    this.isDrawerVisible = true;
  }

  keySearchLength(event: number) {
    this.searchKeyLength = event;
    if (this.searchKeyLength == 0) {
      this.isLoading = false;
      this.isDrawerVisible = true;
      this.searchResult = [];
    }
  }

  searchByEnter(event: any) {
    this.searchResult = event;
    // if (event?.length) {
    this.getFilteredCategory(this.searchResult);
    this.getFilteredState(this.searchResult);
    this.isDrawerVisible = false;
    this.isLoading = false;
    // }
  }

  navigateToDept(searchInput: any) {
    this.recentSearchResult(searchInput);
    this.isDrawerVisible = false;
    this.getSearchResult({ alises: searchInput });
    this.search.setValue('');
    this.storeService.filteredResult = true;
  }

  recentSearchResult(searchInput?: any) {
    let currentLocalStorageList = localStorage.getItem('recentSearch')
      ? JSON.parse(localStorage.getItem('recentSearch') as any)
      : [];
    searchInput && currentLocalStorageList.push(searchInput);
    currentLocalStorageList = Array.from(new Set(currentLocalStorageList));
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(currentLocalStorageList)
    );
    if (currentLocalStorageList.length > 5) {
      currentLocalStorageList.shift();
      // this.recentSearch = currentLocalStorageList.splice(currentLocalStorageList.length - 5, currentLocalStorageList.length-1).reverse();
    }
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(currentLocalStorageList)
    );
    this.recentSearch = currentLocalStorageList;
  }
  
  keyListRecentClick(data: any) {
    // if(this.liveUser){
    //   this.router.navigateByUrl('/search-result');
    //   this.searchResultPojo(abc);
    //   this.showSearch = false;
    //   this.shareDataService.isSearchKey.next(true);
    //   this.searchInAllCntrl.setValue('');
    // }
    // else{
    //   this.shareDataService.isSearchKey.next({key: abc});
    //   this.router.navigateByUrl('/home/search-result');
    //   this.searchResultPojo(abc);
    //   this.showSearch = false;
    //   this.searchInAllCntrl.setValue(abc);
    // }
    this.shareDataService.isSearchKey.next({key: data});
    localStorage.setItem('searchedText', JSON.stringify({key: data}));
    this.router.navigateByUrl('search/search-result');
      // this.searchResultPojo(abc);
      // this.showSearch = false;
      // this.searchInAllCntrl.setValue(abc);
  }
  
  fetchSearchTrendingList() {
    // if(this.liveUser){
    //   this.appContainerProviderService
    //   .getSearchTrendingData()
    //   .subscribe((res) => {
    //     if (res) {
    //       this.trend = res['alisesList'];
    //     }
    //   });
    // }
    // else{
    //   const language = JSON.parse(localStorage.getItem('langDate'));
    //   this.apiService.callSearchAPI('most-searched', {language: language?.lang})
    //   .subscribe((res) => {
    //     if (res) {
    //       this.trend = res.body;
    //     }
    //   });
    // }
    const savedLangConfig = localStorage.getItem('langDate');
    const  lang  = JSON.parse(savedLangConfig!);
      this.callApiService.callSearchAPI('most-searched', {language: lang?.lang})
      .subscribe((res:any) => {
        if (res) {
          this.trend = res;
          this.servicesList = res.services;
        }
      });
  }
  
  
  navigateToScheme(data:any){
    const slug = data.slug;
    const schemeName = this.langHandlerService.currentLang === 'en' ? generateSlug(data?.scheme_name, slug): `${slug}.html`;
    this.router.navigate([`scheme/detail/${schemeName}`]);     // this.showSearch = false;
  }

  ngOnDestroy(): void {
    this.storeService.filteredResult = false;
  }

  removeRecent() {
    localStorage.removeItem('recentSearch');
    this.recentSearch = [];
  }

  navigateToDigilocker(){
    window.open('https://web.umang.gov.in/web_new/home/digilocker/dashboard', '_self');
  }

  onKeyup(event:any){
    this.keyupSubject.next(event);
  }

  
}
